import React from 'react';

type Props = {
  className?: string;
  style?: object;
};

const ClockIcon = ({ className, style }: Props) => {
  return (
    <svg className={className} style={style} id="clock-outline-icon" width="27.888" height="27.888" viewBox="0 0 27.888 27.888">
      <path id="Path_10522" data-name="Path 10522" d="M13.944,0A13.944,13.944,0,1,0,27.888,13.944,13.937,13.937,0,0,0,13.944,0Zm1.089,25.66v-1a1.089,1.089,0,0,0-2.179,0v1A11.76,11.76,0,0,1,2.229,15.034h1a1.089,1.089,0,1,0,0-2.179h-1A11.76,11.76,0,0,1,12.855,2.229v1a1.089,1.089,0,1,0,2.179,0v-1A11.76,11.76,0,0,1,25.659,12.855h-1a1.089,1.089,0,0,0,0,2.179h1A11.76,11.76,0,0,1,15.034,25.66ZM19,17.459A1.089,1.089,0,1,1,17.459,19l-4.285-4.285a1.089,1.089,0,0,1-.319-.77V7.517a1.089,1.089,0,1,1,2.179,0v5.976Z"/>
    </svg>
  );
};

export default ClockIcon;
